"use client";

import React, { useState } from 'react';
import { Icons } from '@/components/icons';
import { SSIcon } from '@/components/ui/ss-icon';
import { SSLogo } from '@/components/ui/ss-logo';
import Link from 'next/link';

interface SignupFooterBannerProps {
    userName: string | null;
    hexColour: string | null;
}

export function SignupFooterBanner({userName, hexColour}: SignupFooterBannerProps) {
    const [isBannerVisible, setIsBannerVisible] = useState(true);
    hexColour = hexColour || '#176CEB';
    return (
        <div>
            { isBannerVisible && (
            <div style={{ backgroundColor: hexColour}} className={`z-50 fixed bottom-0 left-0 right-0 p-1 flex items-center justify-between`}>
                <div className="flex items-center justify-center flex-grow">
                    { userName && (
                        <span className="mr-2 text-white text-xs"><Link href="/register"><span className="font-semibold underline">Join</span></Link> {userName} on</span>
                    )}
                    { !userName && (
                        <Link href="/register"><span className="mr-1 text-white text-xs font-semibold underline">Join</span></Link>
                    )}
                    <SSIcon fill={"#FFFFFF"} fillBack={hexColour} width={24} height={24} />
                    <SSLogo fill="#FFFFFF" width={85} height={21.25} />
                </div>
                <div onClick={() => setIsBannerVisible(false)}>
                    <Icons.close className="mr-2 h-4 w-4 text-white" />
                </div>
            </div>
            )}
        </div>
    )
}